import IncomeAssetWithEventStep from './IncomeAssetWithEventStep'

export default IncomeAssetWithEventStep
